import { render, staticRenderFns } from "./baseSwiper.vue?vue&type=template&id=49b9ffc1&scoped=true"
import script from "./baseSwiper.vue?vue&type=script&lang=js"
export * from "./baseSwiper.vue?vue&type=script&lang=js"
import style0 from "./baseSwiper.vue?vue&type=style&index=0&id=49b9ffc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9ffc1",
  null
  
)

export default component.exports